import { render, staticRenderFns } from "./ProjectWorkload.vue?vue&type=template&id=30002ef6"
import script from "./ProjectWorkload.vue?vue&type=script&lang=js"
export * from "./ProjectWorkload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports